const fieldMapping = {
    firstname: "contactSalesFirstName",
    lastname: "contactSalesLastName",
    email: "contactSalesEmail",
    jobtitle: "contactSalesJobTitle",
    phone: "contactSalesPhone",
    company: "contactSalesCompany",
    company_size__c: "contactSalesCompanySize",
    product_question_hs_forms: "contactSalesProductQuestion",
    how_can_our_consulting_team_help_you: "contactSalesOpenText"
};
export const transformDataToAdaFormat = (input)=>{
    const result = {};
    input.forEach((item)=>{
        const { name, value } = item;
        const mappedKey = fieldMapping[name];
        if (mappedKey) {
            var _value_;
            if (Array.isArray(value) && ((_value_ = value[0]) === null || _value_ === void 0 ? void 0 : _value_.value)) {
                result[mappedKey] = value[0].value;
            } else if (value === null || value === void 0 ? void 0 : value.value) {
                result[mappedKey] = value.value;
            } else {
                result[mappedKey] = value;
            }
        }
    });
    return result;
};
